import React from 'react';
import PropTypes from 'prop-types';
import { flatten } from 'lodash';
import {
  Glyphicon,
  DropdownButton,
  MenuItem
} from 'react-bootstrap';

import ActionButtonListItemComponent from './ActionButtonListItemComponent';

export class ActionButtonListComponent extends React.Component {
  static propTypes = {
    actions: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.object)),
    itemId: PropTypes.number,
    onButtonClick: PropTypes.func.isRequired
  };

  render() {
    const {
      actions,
      itemId,
      onButtonClick
    } = this.props;

    return (
      <DropdownButton noCaret pullRight title={<Glyphicon glyph="option-horizontal" />}
        id={`actions-${itemId}`} style={{ padding: '1px 10px' }}
      >
        {
          actions && actions.length !== 0 ?
            flatten(actions).map((action, index) => {
              return (
                <ActionButtonListItemComponent
                  key={String(index)}
                  actionKey={String(index)}
                  action={action}
                  onButtonClick={onButtonClick}
                />
              );
            }) : <MenuItem key={0}>No Actions Available...</MenuItem>
        }
      </DropdownButton>
    );
  }
}

export default ActionButtonListComponent;


// WEBPACK FOOTER //
// src/Components/ActionButtonListComponent.jsx